import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";
import { baseUrl } from '../../vue.config.js';

Vue.use(Router);

const router = new Router({
    mode: "history",
	base: baseUrl,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            meta: {
                title: "Home",
                auth: false
            }
        },
        {
            path: "/about",
            name: "about",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(/* webpackChunkName: "about" */ "../views/About.vue")
        },
        {
            path: "/accounts",
            name: "accountsList",
            component: () =>
                import(/* webpackChunkName: "accountlist" */ "../components/AccountsList.vue"),
            meta: {
                title: "Accounts",
                auth: true
            }
        },
        {
            path: "/accounts/:account_id",
            name: "accountDetails",
			props: true,
            component: () =>
                import(/* webpackChunkName: "accountdetails" */ "../components/AccountDetails.vue"),
            meta: {
                title: "Account",
                auth: true
            }
        },
        {
            path: "/events",
            name: "eventsList",
            component: () =>
                import(/* webpackChunkName: "eventlist" */ "../components/EventsList.vue"),
            meta: {
                title: "Events",
                auth: true
            }
        },
        {
            path: "/events/:event_id",
            props: true,
            component: () =>
                import(/* webpackChunkName: "eventdetails" */ "../components/EventDetails.vue"),
            children: [{
				name: "eventDetails",
                path: "",
                props: {
                    eventschedule: true,
                    eventdescription: true,
                    gueststatistics: true
                },
                components: {
                        eventschedule: () =>
                            import(/* webpackChunkName: "eventschedule" */ "../components/EventSchedule.vue"),
                        eventdescription: () =>
                            import(/* webpackChunkName: "eventdescription" */ "../components/EventDescription.vue"),
                        gueststatistics: () =>
                            import(/* webpackChunkName: "gueststatistics" */ "../components/GuestsStatistics.vue"),
                }
            }],
            meta: {
                title: "Event detail",
                auth: true
            }
        },
        {
            path: "/events/:event_id/schedule",
            name: "eventSchedule",
            props: true,
            component: () =>
                import(/* webpackChunkName: "eventschedule" */ "../components/EventSchedule.vue"),
            meta: {
                title: "Event schedule",
                auth: true
            }
        },
        {
            path: "/events/:event_id/guests",
            name: "guestsList",
            props: true,
            component: () =>
                import(/* webpackChunkName: "guestslist" */ "../components/GuestsList.vue"),
            meta: {
                title: "Guests",
                auth: true

            }
        },
        {
            path: "/events/:event_id/guests/:guest_id",
            props: true,
            component: () =>
                import(/* webpackChunkName: "guestdetails" */ "../components/GuestDetails.vue"),
            children: [{
				name: "guestDetails",
                path: "/",
                props: {
                    guestprofile: true,
                    guesthistory: true,
					guestbadges: true
                },
                components: {
                    guestprofile: () =>
                        import(/* webpackChunkName: "guestprofile" */ "../components/GuestProfile.vue"),
                    guesthistory: () =>
                        import(/* webpackChunkName: "guesthistory" */ "../components/GuestHistory.vue"),
					guestbadges: () =>
                        import(/* webpackChunkName: "guestbadges" */ "../components/EventsBadges.vue")
                }
            }],
            meta: {
                title: "Guest",
                auth: true
            }
        },{
            path: "/events/:event_id/guests/:guest_id/profile",
            name: "guestprofile",
            props: true,
            component: () =>
                import(/* webpackChunkName: "guestprofile" */ "../components/GuestProfile.vue"),
            meta: {
                title: "Guest profile",
                auth: true
            }
        },
        {
            path: "/signin",
            name: "signin",
            component: () =>
                import(/* webpackChunkName: "signin" */ "../views/Signin.vue"),
            meta: {
                title: "Sign in",
                auth: false
            }
        },
        {
            path: "/signout",
            name: "signout",
            component: () =>
                import(/* webpackChunkName: "signout" */ "../views/Signout.vue"),
            meta: {
                title: "Sign out",
                auth: false
            }
        },
		{
            path: "/clientcredentials",
            name: "clientcredentials",
            component: () =>
                import(/* webpackChunkName: "signin" */ "../views/ClientCredentials.vue"),
            meta: {
                title: "Client Credentials Flow",
                auth: false
            }
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import(/* webpackChunkName: "login" */ "../components/LoginCallback.vue"),
            meta: {
                title: "Authenticating...",
                auth: false
            }
        },
        {
            path: "/logout",
            name: "logout",
            component: () =>
                import(/* webpackChunkName: "logout" */ "../components/LogoutCallback.vue"),
            meta: {
                title: "Authenticating...",
                auth: true
            }
        },
        {
            path: "/account",
            component: () =>
                import(/* webpackChunkName: "profile" */ "../components/UserProfile.vue"),
			children: [{
				name: "account",
                path: "/",
                props: {
                    accountslist: true
                },
                components: {
                        accountslist: () =>
                            import(/* webpackChunkName: "accountslist" */ "../components/AccountsList.vue")
                }
            }],
            meta: {
                title: "Authenticated",
                auth: true
            }
        },
        {
            path: "/error",
            name: "error",
            component: () =>
                import(/* webpackChunkName: "error" */ "../components/ErrorMsg.vue"),
            props: true,
            meta: {
                title: "Error"
            }
        },{
			path: "/events/:event_id/schedule/add",
			name: "addGuestToSchedule",
			component: () =>
                import(/* webpackChunkName: "addGuestToSchedule" */ "../views/AddGuestToSchedule.vue"),
            props: true,
            meta: {
                title: "Adding...",
                auth: true
            }
		},{
			path: "/events/:event_id/schedule/rm",
			name: "removeGuestFromSchedule",
			component: () =>
                import(/* webpackChunkName: "addGuestToSchedule" */ "../views/RemoveGuestFromSchedule.vue"),
            props: true,
            meta: {
                title: "Removing...",
                auth: true
            }
		}
    ]
});

router.beforeEach((to, from, next) => {
    /*
    console.group("router bfe");
    console.debug("to", to);
    console.debug("from", from); 
    console.debug("next", next);
    console.groupEnd();
    */
    // Use the page"s router title to name the page
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }

    try {
        // Redirect to the login page if not authenticated
        // for pages that have "auth: true" set
		if (to.meta) {
	        if (to.meta.auth !== undefined) {
	            if (to.meta.auth) {
	                if (store.getters.isAuthenticated) {
	                    next();
	                } else {
	                    router.push({ name: "login" });
	                }
	            } else {
	                if (store.getters.isAuthenticated) {
	                    router.push({ name: "account" });
	                } else {
	                    next();
	                }
	            }
	        } else {
	            next();
	        }
		}
    } catch (error) {
        console.error(error);
        router.push({ name: "error", params: { message: JSON.stringify(error) } });
    }
});

export default router;